import { OpsOrdersWrapper } from "./ops-orders.style";
import { OpsOrdersSection } from "./sections/ops-orders.section";

export const OpsOrdersPage = () => <OpsOrdersWrapper><OpsOrdersSection /></OpsOrdersWrapper>;
